const customer = 'SPASOLUTION';
let currentProduct;
let iframeSrc;

const carousel = document.querySelector('.flickity-slider');
const thumbnailGallery = document.querySelector('.product-gallery__thumbnail-list');


const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50; // Check every 50ms
    const checkInterval = setInterval(() => {
        if (typeof mazingProjectAvailable === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const slugify = (str) => {
    return str
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\([^)]*\)/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-');
};

const buildSKU = () => {
    const url = window.location.href;
    const match = url.match(/\/products\/([^?]+)/);
    let handle = match ? match[1] : null;
    if (!handle) return null;

    handle = handle
        .replace(/\/$/, '')
        .replace(/\([^)]*\)/g, '')
        .trim()
        .toLowerCase();

    const parts = [];

    const variantSelects = document.querySelectorAll('.product-form__variants .product-form__single-selector');
    if (variantSelects.length) {
        variantSelects.forEach(select => {
            const value = select.value || select.options[select.selectedIndex]?.text || '';
            if (value) parts.push(slugify(value));
        });
    } else {
        const selectedSpans = Array.from(
            document.querySelectorAll('.product-form__option .product-form__selected-value')
        );
        selectedSpans.forEach(el => {
            const value = el.textContent || el.innerText || '';
            if (value) parts.push(slugify(value));
        });
    }

    const sku = [handle, ...parts].filter(Boolean).join('-');
    console.log('New Mazing SKU:', sku);
    return sku;
};



const initializeScript = async () => {
    await waitForMazingFunction;

    console.log('MAZING is ready ...');

    /* AB SECTION START */

    // const waitForElement = (selector, timeout = 55000) => {
    //     return new Promise((resolve) => {
    //         const interval = 50;
    //         let elapsedTime = 0;
    //         const checkInterval = setInterval(() => {
    //             const element = document.querySelector(selector);
    //             if (element) {
    //                 clearInterval(checkInterval);
    //                 resolve(element);
    //             } else if ((elapsedTime += interval) >= timeout) {
    //                 clearInterval(checkInterval);
    //                 resolve();
    //             }
    //         }, interval);
    //     });
    // };

    // const addToCartSelector = 'button[data-action="add-to-cart"]';

    // await waitForElement(addToCartSelector);

    // mazingSetAB({
    //     enabled: true,
    //     addToCartListeners: (callback) => {
    //         document.querySelector(addToCartSelector).addEventListener('click', () => {
    //             console.log('MAZING: addToCartClicked A/B');
    //             callback();
    //         });
    //     }
    // });

    /* AB SECTION END */

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: buildSKU
    });


    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    const iframeDiv = document.createElement('div');
    iframeDiv.className = 'product-gallery__carousel-item';
    iframeDiv.style.height = '480px';
    iframeDiv.style.width = '100%';
    iframeDiv.style.position = 'absolute';
    iframeDiv.style.left = '-50%';
    iframeDiv.style.opacity = '1';
    iframeDiv.id = 'mazing-div';

    const iframe = document.createElement('iframe');
    iframe.src = iframeSrc;
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.style.border = 'none';

    iframeDiv.appendChild(iframe);

    const thumbnailElement = document.createElement('a');
    thumbnailElement.className = 'product-gallery__thumbnail'; // add is-nav-selected for active new thumb
    thumbnailElement.style.height= '70px';
    thumbnailElement.id= 'mazing-thumb';

    const thumbnailDiv = document.createElement('div');
    thumbnailDiv.className = 'aspect-ratio';
    thumbnailDiv.style.height = '100%';

    const svgImgIcon = document.createElement('img');
    svgImgIcon.className = 'image--fade-in lazyloaded';
    svgImgIcon.setAttribute('data-src', 'https://cdn.mazing.link/assets/svg/3D.svg');
    svgImgIcon.setAttribute('alt', 'Mazing Viewer');
    svgImgIcon.src = 'https://cdn.mazing.link/assets/svg/3D.svg';
    svgImgIcon.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';
    svgImgIcon.style.padding = '15%';


    thumbnailDiv.appendChild(svgImgIcon);
    thumbnailElement.appendChild(thumbnailDiv);

    if (thumbnailGallery) {

        thumbnailGallery.insertBefore(thumbnailElement, thumbnailGallery.firstChild.nextSibling)
    }

    if (carousel) {

        carousel.insertBefore(iframeDiv, carousel.firstChild.nextSibling);
    }

    const ensureZoomNoticeVisibility = () => {
        const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
        const isIframeSelected = thumbnailElement.classList.contains('is-nav-selected');

        if (zoomNotice) {
            zoomNotice.style.display = isIframeSelected ? 'none' : '';
        }
    };


    const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');
    const flickityViewport = document.querySelector('.flickity-viewport');

    allThumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            allThumbnails.forEach(thumb => thumb.classList.remove('is-nav-selected'));

            thumbnail.classList.add('is-nav-selected');

            const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
            allCarouselItems.forEach(item => {
                item.classList.add('item--hidden');
                item.classList.remove('is-selected')
                item.setAttribute('aria-hidden', 'true');
            });

            const selectedCarouselItem = allCarouselItems[index];
            if (selectedCarouselItem) {
                selectedCarouselItem.classList.remove('item--hidden');
                selectedCarouselItem.classList.add('is-selected');
                selectedCarouselItem.removeAttribute('aria-hidden');
            }


            if (thumbnail === thumbnailElement) {
                flickityViewport.style.height = '480px';
            } else {
                flickityViewport.style.height = '';
            }

            ensureZoomNoticeVisibility();
        });
    });

    ensureZoomNoticeVisibility();

    const productVariants = document.querySelector('.product-form__variants');
    let colorsContainer;
    let colors;
    let colorSelect;

    if (productVariants) {
        colorsContainer = productVariants.querySelector('.color-swatch-list');
        if (colorsContainer) {
            colors = colorsContainer.querySelectorAll('.color-swatch');
        } else {
            colorSelect = productVariants.querySelector('.product-form__single-selector');
        }
    }

    async function handleColorChange(colorValue) {
        console.log('COLOR VALUE:', colorValue);
        if (!colorValue) return;

        let cleanColor = colorValue.replace('#', '').replace(/\s+/g, '').toLowerCase();

        const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
        const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');

        const mazingThumb = document.getElementById('mazing-thumb');
        const mazingDiv = document.getElementById('mazing-div');

        if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
        if (mazingDiv) {
            mazingDiv.classList.add('item--hidden');
            mazingDiv.classList.remove('is-selected');
            mazingDiv.setAttribute('aria-hidden', 'true');
        }

        for (let i = 0; i < allThumbnails.length; i++) {
            const thumb = allThumbnails[i];
            const item = allCarouselItems[i];

            if (thumb !== mazingThumb) {
                thumb.classList.add('is-nav-selected');
                item.classList.remove('item--hidden');
                item.classList.add('is-selected');
                item.removeAttribute('aria-hidden');
                break;
            }
        }

        const flickityViewport = document.querySelector('.flickity-viewport');
        if (flickityViewport) flickityViewport.style.height = '';

        const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
        if (zoomNotice) zoomNotice.style.display = '';

        // set new iframeSrc
        const newIframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: buildSKU
        });

        if (newIframeSrc) {
            iframeSrc = newIframeSrc;
            const iframe = document.querySelector('#mazing-div iframe');
            if (iframe) {
                iframe.src = newIframeSrc;
            }

            await mazingRefreshSKU(buildSKU(), customer);
        } else {
            console.log('No Mazing Project found! Return;');
        }
    }

    if (colors) {
        // CASE 1: Farb-Swatches
        colors.forEach(div => {
            const label = div.querySelector('.color-swatch__item');

            label.addEventListener('click', () => {
                const colorValue = label.getAttribute('title');
                handleColorChange(colorValue);
            });
        });
    } else if (colorSelect) {
        // CASE 2: Dropdown-Auswahl
        colorSelect.addEventListener('change', (event) => {
            const selectedOption = event.target.options[event.target.selectedIndex];
            const colorValue = selectedOption.value;
            handleColorChange(colorValue);
        });
    }



    // --- HANDLE SIZE DROPDOWN SELECTION ---
    const sizeSelect = productVariants.querySelector('select.product-form__single-selector');

    if (sizeSelect) {
        sizeSelect.addEventListener('change', async () => {
            const selectedSize = sizeSelect.value.trim();
            const cleanSize = selectedSize.replace(/\s/g, '').toLowerCase();
            console.log('SELECTED SIZE:', selectedSize);

            const allCarouselItems = document.querySelectorAll('.product-gallery__carousel-item');
            const allThumbnails = document.querySelectorAll('.product-gallery__thumbnail');

            const mazingThumb = document.getElementById('mazing-thumb');
            const mazingDiv = document.getElementById('mazing-div');

            if (mazingThumb) mazingThumb.classList.remove('is-nav-selected');
            if (mazingDiv) {
                mazingDiv.classList.add('item--hidden');
                mazingDiv.classList.remove('is-selected');
                mazingDiv.setAttribute('aria-hidden', 'true');
            }

            for (let i = 0; i < allThumbnails.length; i++) {
                const thumb = allThumbnails[i];
                const item = allCarouselItems[i];

                if (thumb !== mazingThumb) {
                    thumb.classList.add('is-nav-selected');
                    item.classList.remove('item--hidden');
                    item.classList.add('is-selected');
                    item.removeAttribute('aria-hidden');
                    break;
                }
            }

            const flickityViewport = document.querySelector('.flickity-viewport');
            if (flickityViewport) flickityViewport.style.height = '';

            const zoomNotice = document.querySelector('.product-gallery__zoom-notice');
            if (zoomNotice) zoomNotice.style.display = '';

            // set new iframeSrc
            const newIframeSrc = await mazingProjectAvailable({
                customerName: customer,
                getSKU: buildSKU

            });

            if (newIframeSrc) {
                iframeSrc = newIframeSrc;
                const iframe = document.querySelector('#mazing-div iframe');
                if (iframe) {
                    iframe.src = newIframeSrc;
                }

                await mazingRefreshSKU(buildSKU(), customer);
            } else {
                console.log('No Mazing Project found for this size. Return;')
            }
        });
    }




    document.addEventListener('change', async (e) => {
        if (!e.target.closest('.product-form__variants')) return;
        if (!e.target.classList.contains('product-form__single-selector')) return;

        const newIframeSrc = await mazingProjectAvailable({
            customerName: customer,
            getSKU: buildSKU
        });

        if (newIframeSrc) {
            const iframe = document.querySelector('#mazing-div iframe');
            if (iframe) iframe.src = newIframeSrc;

            //try { mazingRefreshSKU && await mazingRefreshSKU(buildSKU(), customer); } catch(e){}
        }
    });

};

const initButton = async () => {
    await waitForMazingFunction;

    await mazing({
        customerName: customer,
        buttonConfiguration: {
            customStyle: `
                .product-form__option {
                    position: relative;
                }
                
                .product-form__option .select-wrapper--primary {
                    display: inline-block;
                }
                
                .mazing-button-container {
                    position: absolute !important;
                    top: 0;
                    left: 170px;
                    height: 100%;
                    display: flex;
                    align-items: end;
                
                    button {
                        padding-left: 24px;
                        padding-right: 24px;
                        border-radius: 0px;
                    }
                }
                
                .mazing-threed-btn-text{
                    color: #1E2D7D;
                }
                
                .mazing-ar-btn-text{
                    color: #1E2D7D;
                }
                
                .mazing-threed-btn-icon {
                    filter: brightness(0) saturate(100%) invert(15%) sepia(57%) saturate(2222%) hue-rotate(215deg) brightness(102%) contrast(99%);
                } 
                
                .mazing-ar-btn-icon {
                    filter: brightness(0) saturate(100%) invert(15%) sepia(57%) saturate(2222%) hue-rotate(215deg) brightness(102%) contrast(99%);
                }

                @media (max-width: 768px) {
                   
                   .mazing-threed-btn,
                   .mazing-ar-btn { 
                      padding-left: 12px !important;
                      padding-right: 20px !important;

                      span {
                          line-height: normal;
                      }
                   }
                }
            `,
            placementSelector: '.product-form__option',
            threedBtn: {
                enabled: true,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: false,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in Room",
                        "de": "Im Raum anzeigen",
                        "fr": "Voir dans votre espace",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: buildSKU
    });

    const checkAndBindButton = () => {
        const button = document.getElementById('mazing-threed-btn');
        if (button && !button.dataset.bound) {
            button.dataset.bound = "true";
            button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log('Mazing 3D Button clicked (submit unterdrückt)');
            });
        } else {
            setTimeout(checkAndBindButton, 100);
        }
    };

    checkAndBindButton();

    console.log('Mazing initialized.');
};

//initButton();
initializeScript();
